"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileData = void 0;
const fileToBase64String = async (file) => new Promise((resolve, reject) => {
    try {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result.replace('data:', '').replace(/^.+,/, '');
            resolve(base64String);
        };
        reader.readAsDataURL(file);
    }
    catch {
        reject('unable to encode file');
    }
});
const getFileData = async (file) => {
    const filename = file.name.split('.').slice(0, -1).join();
    const extension = file.name.split('.').pop() || '';
    const encodedFile = await fileToBase64String(file);
    return { filename, extension, encodedFile };
};
exports.getFileData = getFileData;
